var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.displayFlag,
      callback: function callback($$v) {
        _vm.displayFlag = $$v;
      },
      expression: "displayFlag"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline red white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proximityWarningHeader')) + "\n    ")]), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proximityWarningBody', [this.formattedDistance])) + "\n    ")]), _c('v-divider'), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    nativeOn: {
      "click": function click($event) {
        _vm.displayFlag = false;
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n      ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    on: {
      "click": _vm.confirmProximity
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proximityConfirm')) + "\n      ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }